import { PDFDocument } from 'pdf-lib';
import { pdfjs } from 'react-pdf';

const SCALE = 1.5;

export const loadThumbnails = async (pdfSrc: string) => {
  const pdfBytes = await fetch(pdfSrc).then((res) => res.arrayBuffer());
  const pdfDoc = await PDFDocument.load(pdfBytes);
  const pdfData = await pdfDoc.saveAsBase64({ dataUri: true });

  const pdfDocument = await pdfjs.getDocument(pdfData);
  const pdfPages: any = [];

  await pdfDocument.promise.then(async (pdf) => {
    const pageCount = pdf._pdfInfo.numPages;
    const pageArray = [...new Array(pageCount).keys()];

    for (const pageNumber of pageArray) {
      await pdf.getPage(pageNumber + 1).then((page) => {
        const viewport = page.getViewport({ scale: SCALE });
        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d');

        canvas.height = viewport.height;
        canvas.width = viewport.width;

        const renderContext: any = {
          canvasContext: context,
          viewport,
        };
        const renderTask = page.render(renderContext);

        return renderTask.promise.then(() => {
          const thumbnail = canvas.toDataURL();

          return pdfPages.push({
            pageNumber: pageNumber + 1,
            thumbnail,
          });
        });
      });
    }
  });

  return pdfPages;
};

export const getPdfPageCountFromFile = async (file: File): Promise<number> => {
  const pdfBytes = await file.arrayBuffer();
  const pdfDoc = await PDFDocument.load(pdfBytes);
  // Use getPages() length to be compatible with pdf-lib versions
  return pdfDoc.getPages().length;
};
